import type { ImportQueueStatus } from '@lib/import-queue-ui/types/import-queue-status';

import type { ListingImportQueueItemStatus } from '../types/listing-import-queue-item';

export function mapListingImportToQueueStatus(
  status: ListingImportQueueItemStatus
): ImportQueueStatus {
  switch (status) {
    case 'queued':
      return 'queued';
    case 'uploading':
      return 'uploading';
    case 'processing':
      return 'processing';
    case 'done':
      return 'done';
    case 'failed':
      return 'failed';
  }
}
